import React, { useEffect } from "react";
import { Switch, Route, useHistory, Redirect } from "react-router-dom";
import { useRouteMatch } from "react-router";

import BaseLayout from "../../components/layouts/BaseLayout";
import useSetState from "../../hooks/useSetState";
import VehicleTemplates from "./VehicleTemplates";
import TemplateValueMappers from "./ValuesMappings/ValuesMappings";

const VehicleTemplatesContainer = () => {
  const history = useHistory();
  const match = useRouteMatch({
    path: "/config/vehicle/templates/:activeTabURL",
    strict: true,
    sensitive: true,
  });
  const { activeTabURL } = match?.params as any;

  const tabs = [
    { label: "Templates", value: "templates" },
    { label: "Value Mappings", value: "value_mappings" },
  ];

  const [{ activeTab }, setState] = useSetState({
    activeTab: "templates",
  });

  useEffect(() => {
    setState({ activeTab: activeTabURL });
  }, [activeTabURL]);

  const handleTabClick = (event, newValue) => {
    history.push(`/config/vehicle/templates/${newValue}`);
    setState({ activeTab: newValue });
  };
  return (
    <BaseLayout
      title="Vehicle Templates"
      tabs={tabs}
      handleTabChange={handleTabClick}
      activeTab={activeTab}
    >
      <Switch>
        <Route path="/config/vehicle/templates/templates" exact>
          <VehicleTemplates />
        </Route>
        <Route path="/config/vehicle/templates/value_mappings" exact>
          <TemplateValueMappers />
        </Route>
        <Redirect to="/config/vehicle/templates/templates" />
      </Switch>
    </BaseLayout>
  );
};

export default VehicleTemplatesContainer;
